import { HVIcon } from "@repo/HVComponents";
import { useMemo, useState } from "react";
import { useLang } from "@hooks/useLang";
import * as S from "../LeftMenu.styled";

export type ObjectType = "People" | "Cart" | "Vehicle";

interface ObjectTypeButtonProps {
  defaultType?: ObjectType;
  onChange: (type: ObjectType) => void;
}
export const ObjectTypeButton = (props: ObjectTypeButtonProps) => {
  const { translate } = useLang();
  const OBJECT_TYPE_LIST = useMemo(
    () => [
      {
        iconName: "people" as const,
        label: translate("people"),
        key: "People" as ObjectType
      },
      {
        iconName: "shopping-cart" as const,
        label: translate("cart"),
        key: "Cart" as ObjectType
      },
      {
        iconName: "vehicle" as const,
        label: translate("vehicle"),
        key: "Vehicle" as ObjectType
      }
    ],
    [translate]
  );
  const [type, setType] = useState(props.defaultType);

  const handleClickType = (selectedType: ObjectType) => {
    setType(selectedType);
    props.onChange(selectedType);
  };

  return (
    <S.ObjectTypeWrap>
      {OBJECT_TYPE_LIST.map((item) => {
        const { iconName, label, key } = item;
        const isSelected = type === key;
        return (
          <S.ObjectTypeButton
            key={`${iconName}_${label}`}
            selected={isSelected}
            onClick={() => {
              if (!isSelected) {
                handleClickType(key);
              }
            }}
          >
            <HVIcon
              name={iconName}
              svgProps={{
                width: "28",
                height: "28"
              }}
            />
            {label}
          </S.ObjectTypeButton>
        );
      })}
    </S.ObjectTypeWrap>
  );
};
